import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    gap: 16px;
    background: #f5f5f5;
    box-shadow: 0 2.456px 3.684px 0 rgba(0, 0, 0, 0.25);

    @media (max-width: 1440px) {
        padding: 16px 24px;
        justify-content: space-between;
        align-items: flex-start;
    }
`

export const Content = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;

    @media (max-width: 1440px) {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
`

export const Text1 = styled.span`
    width: 296px;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    color: #363636;

    @media (max-width: 1440px) {
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 115%;
        color: #0037ff;
        width: fit-content;
    }
`

export const Text2 = styled.span`
    width: 449px;
    font-size: 14px;
    font-style: normal;
    line-height: 115%;
    color: #363636;

    @media (max-width: 1440px) {
        width: fit-content;
    }

    @media (max-width: 360px) {
        display: none;
    }
`

export const Text2Mobile = styled(Text2)`
    display: none;

    @media (max-width: 360px) {
        display: block;
    }
`

export const Img = styled.img`
    @media (max-width: 1440px) {
        display: none;
    }
`

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 16px;

    p {
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            margin-right: 4px;
            display: block !important;
        }
    }
`

export const CloseButton = styled.button`
    cursor: pointer;
    background: none;
    outline: none;
    line-height: normal;

    &:hover {
        opacity: 0.8;
    }
`

export const CloseButtonImg = styled.img`
    width: 100%;
`
